import React, { useState, useEffect, useRef } from "react";
import { Navbar, Nav, NavDropdown, Container } from "react-bootstrap";
import { useNavigate, Link } from "react-router-dom"; // ✅ Importamos useNavigate y Link
import "../styles/tubo_cerquero.css";
import "bootstrap/dist/css/bootstrap.min.css";
import logo from "../img/logoAmnorte.png";
import tubocuadrado from "../img/tub-cuadrada.png";

const menuItems = [
  { name: "Inicio", link: "/" },
  { name: "Nosotros", link: "/nosotros" },
  {
    name: "Productos",
    link: "/productos",
    dropdown: [
      { name: "Tubería Redonda", link: "/tuberia-redonda" },
      { name: "Tubería Redonda-Cédulas", link: "/tuberia-cedulas" },
      { name: "Tubo Cerquero", link: "/tubo-cerquero" },
      { name: "Tubería Cuadrada", link: "/tuberia-cuadrada" },
      { name: "PTR y Perfiles Rectangulares", link: "/ptr" },
      { name: "Perfiles Puerta", link: "/perfil-puerta" },
      { name: "Perfiles Ventana", link: "/perfil-ventana" },
      { name: "Ángulos y Soleras", link: "/angulos-soleras" },
      { name: "Lámina R-101", link: "/lamina-R-101" },
    ],
  },
  {
    name: "Servicios",
    link: "/servicio",
    dropdown: [
      { name: "Corte Láser", link: "/servicio#corte_laser" },
      { name: "Corte de Tubo", link: "/servicio#corte_tubo" },
      { name: "Doblez", link: "/servicio#doblez" },
      { name: "Doblez de Tubo", link: "/servicio#doblez-tubo" },
    ],
  },
  { name: "Contácto", link: "/contacto" },
];

const NavBar = () => {
  const navigate = useNavigate(); // ✅ Hook para navegación

  const [navbarColor, setNavbarColor] = useState("#354a66");

  useEffect(() => {
    const handleScroll = () => {
      const scrollY = window.scrollY;
      const carouselElement = document.getElementById("main-carousel");
      const carouselHeight = carouselElement ? carouselElement.clientHeight : 500;

      if (scrollY < carouselHeight / 2) {
        setNavbarColor("#354a66");
      } else {
        setNavbarColor("#354a66");
      }
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  return (
    <Navbar expand="lg" style={{ background: navbarColor, transition: "background 0.3s ease-in-out" }} fixed="top" className="navbar-custom">
      <Container>
        <Navbar.Brand as={Link} to="/" style={{ color: "#fff" }}>
          <img src={logo} alt="Logo Aceros y Metales" height="50" className="me-2" />
          <span>Aceros y Metales</span>
        </Navbar.Brand>
        <Navbar.Toggle aria-controls="navbarNav" />
        <Navbar.Collapse id="navbarNav">
          <Nav className="ms-auto">
            {menuItems.map((item, index) =>
              item.dropdown ? (
                <NavDropdown key={index} title={item.name} id={`dropdown-${index}`} style={{ color: "#fff" }}>
                  {/* ✅ Hacer que "Productos" sea clickeable y navegue */}
                  {item.link && (
                    <NavDropdown.Item onClick={() => navigate(item.link)} style={{ color: "#fff", fontWeight: "bold" }}>
                      {item.name}
                    </NavDropdown.Item>
                  )}
                  <NavDropdown.Divider />
                  {item.dropdown.map((subItem, subIndex) => (
                    <NavDropdown.Item key={subIndex} href={subItem.link} style={{ color: "#fff" }}>
                      {subItem.name}
                    </NavDropdown.Item>
                  ))}
                </NavDropdown>
              ) : (
                <Nav.Link as={Link} to={item.link} key={index} style={{ color: "#fff", transition: "color 0.3s ease" }}>
                  {item.name}
                </Nav.Link>
              )
            )}
          </Nav>
        </Navbar.Collapse>
      </Container>
    </Navbar>
  );
};
const TuboRedondo = () => {
  return (
    <section>
      <div className="servicios-container" style={{ textAlign: "center" }}>
        <div
          className="servicios-title"
          style={{
            marginTop: "130px",
            fontSize: "3rem",
            fontWeight: "bold",
            color: "#f58634",
            textShadow: "2px 2px 5px rgba(0, 0, 0, 0.3)",
            padding: "10px",
            animation: "fadeIn 1s ease-in-out",
            textAlign: "center",
          }}
        >
          Tuberia Cuadrada
        </div>
      </div>
      <div className="row" style={{ marginTop: '50px', display: 'flex', alignItems: 'center' }}>
        {/* Descripción del producto */}
        <div className="col-md-4 d-flex justify-content-center align-items-center" style={{ height: '450px', textAlign: 'justify' }}>
          <br /><br />
          <p style={{ marginLeft: '10px', textAlign: 'justify' }}>
            Es un perfil hueco de acero con sección transversal cuadrada, se caracteriza por su
            resistencia, versatilidad y facilidad de soldadura. Está disponible en distintos calibres.
            <br /><br />
            <img src={tubocuadrado} alt="Tuberia Cuadrada" style={{ maxWidth: '350px', marginLeft: '30px' }} />
          </p>
        </div>

        {/* Tabla del producto */}
        <div className="col-md-8">
          {/* Contenedor con scroll para las tres tablas */}
          <div style={{ maxHeight: '70vh', overflowY: 'auto', maxWidth: '100%', margin: '0 auto' }}>
            <table class="table table-striped">
              <thead>
                <tr>
                  <th colspan="8" className="text-center bg-orange text-white"
                    style={{ fontSize: "1.5rem", padding: "10px", background:'#f58634' }}>
                    Tubería Cuadrada
                  </th>
                </tr>
                <tr>
                  <th style={{ background: "#ffe4b2", color: "#000" }}>Descripción</th>
                  <th style={{ background: "#ffe4b2", color: "#000" }}>Díametro</th>
                  <th style={{ background: "#ffe4b2", color: "#000" }}>Calibre</th>
                  <th style={{ background: "#ffe4b2", color: "#000" }}>Espesor</th>
                  <th style={{ background: "#ffe4b2", color: "#000" }}>Inventario</th>
                  <th style={{ background: "#ffe4b2", color: "#000" }}>Longitud</th>
                  <th style={{ background: "#ffe4b2", color: "#000" }}>Piezas x Atado</th>
                  <th style={{ background: "#ffe4b2", color: "#000" }}>Kilogramo x Metro</th>
                </tr>
              </thead>
              <tbody>
                <tr style={{ background: "#fff" }}>
                  <td rowspan="2">C-050</td>
                  <td rowspan="2">0.500"</td>
                  <td>20</td>
                  <td>0.0359</td>
                  <td>N/GV</td>
                  <td>6</td>
                  <td>231</td>
                  <td>0.34</td>
                </tr>
                <tr style={{ background: "#ffe4b2" }}>
                  <td>18"</td>
                  <td>0.0478"</td>
                  <td>N</td>
                  <td>6</td>
                  <td>231</td>
                  <td>0.34</td>
                </tr>
                <tr style={{ background: "#fff" }}>
                  <td rowspan="3">C-075</td>
                  <td rowspan="3">0.750"</td>
                  <td>20</td>
                  <td>0.0359</td>
                  <td>N/PR/GV</td>
                  <td>6</td>
                  <td>231</td>
                  <td>0.44</td>
                </tr>
                <tr style={{ background: "#ffe4b2" }}>
                  <td>18</td>
                  <td>0.0478</td>
                  <td>N/PR/GV</td>
                  <td>6</td>
                  <td>120</td>
                  <td>0.68</td>
                </tr>
                <tr style={{ background: "#fff" }}>
                  <td>14</td>
                  <td>0.0747</td>
                  <td>N</td>
                  <td>6</td>
                  <td>120</td>
                  <td>1.02</td>
                </tr>
                <tr style={{ background: "#ffe4b2" }}>
                  <td style={{ background: "#f0f0f0f7" }} rowspan="7">C-100</td>
                  <td style={{ background: "#f0f0f0f7" }} rowspan="7">1.000"</td>
                  <td>20</td>
                  <td>0.0359</td>
                  <td>N/PR/GV</td>
                  <td>6</td>
                  <td>100</td>
                  <td>0.7</td>
                </tr>
                <tr style={{ background: "#fff;" }}>
                  <td>18</td>
                  <td>0.0478</td>
                  <td>N/PR/GV</td>
                  <td>6</td>
                  <td>100</td>
                  <td>0.92</td>
                </tr>
                <tr style={{ background: "#ffe4b2" }}>
                  <td>16</td>
                  <td>0.0478</td>
                  <td>N/GN</td>
                  <td>6</td>
                  <td>100</td>
                  <td>1.14</td>
                </tr>
                <tr style={{ background: "#fff" }}>
                  <td>14</td>
                  <td>0.0747</td>
                  <td>N/GN</td>
                  <td>6</td>
                  <td>100</td>
                  <td>1.4</td>
                </tr>
                <tr style={{ background: "#ffe4b2" }}>
                  <td>12</td>
                  <td>0.1046</td>
                  <td>N</td>
                  <td>6</td>
                  <td>80</td>
                  <td>1.9</td>
                </tr>
                <tr style={{ background: "#fff" }}>
                  <td>11</td>
                  <td>0.1196</td>
                  <td>N</td>
                  <td>6</td>
                  <td>80</td>
                  <td>1.94</td>
                </tr>
                <tr style={{ background: "#ffe4b2" }}>
                  <td>10</td>
                  <td>0.1345</td>
                  <td>N</td>
                  <td>6</td>
                  <td>80</td>
                  <td>2.12</td>
                </tr>
                <tr style={{ background: "#fff" }}>
                  <td rowspan="5">C-125</td>
                  <td rowspan="5">1.250"</td>
                  <td>20</td>
                  <td>0.0359</td>
                  <td>PR/GV</td>
                  <td>6</td>
                  <td>81</td>
                  <td>0.88</td>
                </tr>
                <tr style={{ background: "#ffe4b2" }}>
                  <td>18</td>
                  <td>0.0478</td>
                  <td>N/PR/GV</td>
                  <td>6</td>
                  <td>81</td>
                  <td>1.16</td>
                </tr>
                <tr style={{ background: "#fff" }}>
                  <td>16</td>
                  <td>0.0598</td>
                  <td>N</td>
                  <td>6</td>
                  <td>81</td>
                  <td>1.44</td>
                </tr>
                <tr style={{ background: "#ffe4b2" }}>
                  <td>14</td>
                  <td>0.0747</td>
                  <td>N/GN</td>
                  <td>6</td>
                  <td>81</td>
                  <td>1.78</td>
                </tr>
                <tr style={{ background: "#fff" }}>
                  <td>12</td>
                  <td>0.1046</td>
                  <td>N</td>
                  <td>6</td>
                  <td>63</td>
                  <td>2.42</td>
                </tr>
                <tr style={{ background: "#ffe4b2" }}>
                  <td style={{ background: "#f0f0f0f7" }} rowspan="6">C-150</td>
                  <td style={{ background: "#f0f0f0f7" }} rowspan="6">1.500"</td>
                  <td>20</td>
                  <td>0.0359</td>
                  <td>PR/GV</td>
                  <td>6</td>
                  <td>49</td>
                  <td>1.06</td>
                </tr>
                <tr style={{ background: "#fff" }}>
                  <td>18</td>
                  <td>0.0478</td>
                  <td>N/PR/GV</td>
                  <td>6</td>
                  <td>49</td>
                  <td>1.4</td>
                </tr>
                <tr style={{ background: "#ffe4b2" }}>
                  <td>16</td>
                  <td>0.0598</td>
                  <td>N/GN</td>
                  <td>6</td>
                  <td>49</td>
                  <td>1.74</td>
                </tr>
                <tr style={{ background: "#fff" }}>
                  <td>14</td>
                  <td>0.0747</td>
                  <td>N/GN</td>
                  <td>6</td>
                  <td>49</td>
                  <td>2.15</td>
                </tr>
                <tr style={{ background: "#ffe4b2" }}>
                  <td>12</td>
                  <td>0.1046</td>
                  <td>N</td>
                  <td>6</td>
                  <td>49</td>
                  <td>2.95</td>
                </tr>
                <tr style={{ background: "#fff" }}>
                  <td>11</td>
                  <td>0.1196</td>
                  <td>N</td>
                  <td>6</td>
                  <td>49</td>
                  <td>3.15</td>
                </tr>
                <tr style={{ background: "#ffe4b2" }}>
                  <td style={{ background: "#f0f0f0f7" }}>C-175</td>
                  <td style={{ background: "#f0f0f0f7" }}> 1.750"</td>
                  <td>14</td>
                  <td>0.0747</td>
                  <td>GN</td>
                  <td>6</td>
                  <td>60</td>
                  <td>2.53</td>
                </tr>
                <tr style={{ background: "#fff" }}>
                  <td rowspan="3">C-200"</td>
                  <td rowspan="3">2.000"</td>
                  <td>18</td>
                  <td>0.0478</td>
                  <td>PR/GV</td>
                  <td>6</td>
                  <td>50</td>
                  <td>1.89</td>
                </tr>
                <tr style={{ background: "#ffe4b2" }}>
                  <td>16</td>
                  <td>0.0598</td>
                  <td>N/GN</td>
                  <td>6</td>
                  <td>50</td>
                  <td>2.35</td>
                </tr>
                <tr style={{ background: "#fff" }}>
                  <td>14</td>
                  <td>0.0747</td>
                  <td>N/GN</td>
                  <td>6</td>
                  <td>50</td>
                  <td>2.91</td>
                </tr>
                <tr style={{ background: "#ffe4b2" }}>
                  <td rowspan="6" style={{ background: "#f0f0f0f7" }}>C-200</td>
                  <td rowspan="6" style={{ background: "#f0f0f0f7" }}> 2.000"</td>
                  <td>12</td>
                  <td>0.1046</td>
                  <td>N</td>
                  <td>6</td>
                  <td>40</td>
                  <td>4.01</td>
                </tr>
                <tr style={{ background: "#fff" }}>
                  <td>11</td>
                  <td>0.1196</td>
                  <td>N</td>
                  <td>6</td>
                  <td>40</td>
                  <td>4.36</td>
                </tr>
                <tr style={{ background: "#ffe4b2" }}>
                  <td>10</td>
                  <td>0.1345</td>
                  <td>N</td>
                  <td>6</td>
                  <td>40</td>
                  <td>4.84</td>
                </tr>
                <tr style={{ background: "#fff" }}>
                  <td>9</td>
                  <td>0.1495</td>
                  <td>N</td>
                  <td>6.1</td>
                  <td>40</td>
                  <td>5.31</td>
                </tr>
                <tr style={{ background: "#ffe4b2" }}>
                  <td>3/16</td>
                  <td>0.188</td>
                  <td>N</td>
                  <td>6.1</td>
                  <td>40</td>
                  <td>6.43</td>
                </tr>
                <tr style={{ background: "#fff" }}>
                  <td>1/4</td>
                  <td>0.25</td>
                  <td>N</td>
                  <td>6.1</td>
                  <td>40</td>
                  <td>8.04</td>
                </tr>
                <tr style={{ background: "#ffe4b2" }}>
                  <td rowspan="6" style={{ background: "#f0f0f0f7" }}>C-250</td>
                  <td rowspan="6" style={{ background: "#f0f0f0f7" }}> 2.500"</td>
                  <td>14</td>
                  <td>0.0747</td>
                  <td>N/GN</td>
                  <td>6</td>
                  <td>36</td>
                  <td>3.67</td>
                </tr>
                <tr style={{ background: "#fff" }}>
                  <td>11</td>
                  <td>0.1196</td>
                  <td>N</td>
                  <td>6</td>
                  <td>27</td>
                  <td>5.57</td>
                </tr>

              </tbody>
            </table>

            <ul>
              <p>Productos especiales sujetos a mínimos de fabricación. </p>
              <p>Disponibles en RF con acabado Pintado y Galvanizado.</p>
              <p>Para factibilidad en diferentes calibres, longitudes y acabados pregunte a su asesor de
                ventas.</p>
              <ul>
                <li>N-Natural.</li>
                <li>PR-Pintado Rojo</li>
                <li>GN-Galvanizado</li>
              </ul>
            </ul>
          </div>
        </div>
      </div>
    </section>
  );
}

const Servicios = () => {
  return (
    <section className="nservicios text-center my-5">
      <h3>Nuestros Servicios</h3>
      <div className="servicios-container">
        <Link to='/servicio#corte_laser' style={{ textDecoration: 'none' }}>
          <div className="servicio">
            <p>Corte Láser</p>
            <img src={require("../img/laser.png")} alt="Corte Láser" />
          </div>
        </Link>
        <Link to='/servicio#corte_tubo' style={{ textDecoration: 'none' }} >
          <div className="servicio">
            <p>Corte de Tubo</p>
            <img src={require("../img/corte_recto.png")} alt="Corte Recto" />
          </div>
        </Link>
        <Link to='/servicio#doblez' style={{ textDecoration: 'none' }}>
          <div className="servicio">
            <p>Doblez de Lámina</p>
            <img src={require("../img/dobladora-lamina.png")} alt="Doblez de Lámina" />
          </div>
        </Link>
        <Link to='/servicio#doblez-tubo' style={{textDecoration:'none'}}>
          <div className="servicio">
            <p style={{ fontSize: "13px" }}>Doblez de Tubo</p>
              <img src={require("../img/dobladora-tubo.JPG")} alt="Doblez de Tubo" />
          </div>
        </Link>

      </div>
    </section>
  );
};

const WhatsAppButton = () => (
  <a href="https://wa.me/525547829794" target="_blank" rel="noopener noreferrer" className="whatsapp-button">
    <img src="https://upload.wikimedia.org/wikipedia/commons/6/6b/WhatsApp.svg" alt="WhatsApp" style={{ width: "60px", height: "60px" }} />
  </a>
);

const Footer = () => (
  <footer className="footer">
    <div className="container fluid">
      <div className="row d-flex align-items-stretch">
        <div className="col-md-4 mb-4 d-flex flex-column justify-content-center">
          <div className="contact-info text-center" style={{ textAlign: "justify" }}>
            <h5>CONTÁCTANOS</h5>
            <p style={{ color: "#fff" }}><strong>Email:</strong> contacto@aymnorte.com.mx</p>
            <p style={{ color: "#fff" }}><strong>Teléfono:</strong> +52 55 4782 9794</p>
          </div>
        </div>
        <div className="col-md-4 mb-4 d-flex flex-column justify-content-center">
          <div className="address text-center" style={{ textAlign: "justify" }}>
            <h5>CORPORATIVO</h5>
            <p>Calzada Mariano Escobedo #476,<br />Piso 12 Int. 1200 B, Anzures,<br />Miguel Hidalgo, Ciudad de México, C.P. 11590</p>
          </div>
        </div>
        <div className="col-md-4 mb-4 d-flex flex-column justify-content-center">
          <div className="address text-center" style={{ textAlign: "justify" }}>
            <h5>CEDIS</h5>
            <p>Carretera Federal México-Querétaro KM 100,<br />San Miguel de la Victoria, Jilotepec,<br />Estado de México, C.P. 54270</p>
          </div>
        </div>
      </div>
      <div className="row text-center">
        <div className="col-md-12">
          <p style={{ color: "#fff" }}>AMNorte Aceros y Metales &copy; 2025 - Todos los derechos reservados</p>
          <p>
            <Link to='/Avisos_Privacidad'>
              <a style={{ color: "white", textDecoration: "none" }}>Aviso de Privacidad |</a>
            </Link>
            <Link to='/Terminos_y_Condiciones'>
              <a style={{ color: "white", textDecoration: "none" }}> Términos y Condiciones</a>
            </Link>
          </p>
        </div>
      </div>
    </div>
  </footer>
);

const Tuberia_cuadrada = () => {
  return (
    <div>
      <NavBar />
      <TuboRedondo />
      <Servicios />
      <WhatsAppButton />
      <Footer />
    </div>
  );
};

export default Tuberia_cuadrada;
